import { ListSkeleton } from '../List';
import { TextSkeleton } from '../Skeleton';
import {
    SidePanel,
    SidePanelBody,
    SidePanelCloseButton,
    SidePanelHeader,
    SidePanelHeaderActions,
    SidePanelHeaderMain,
    SidePanelHeaderTitle,
} from './SidePanel';

/**
 * Skeleton of a side panel sheet.
 */
export function SidePanelSkeleton(props: { onClose?: () => void }) {
    const { onClose = () => {} } = props;
    return (
        <SidePanel onClose={onClose}>
            <SidePanelHeader>
                <SidePanelHeaderMain>
                    <SidePanelHeaderTitle>
                        <TextSkeleton>Side panel title</TextSkeleton>
                    </SidePanelHeaderTitle>
                    <SidePanelHeaderActions>
                        <SidePanelCloseButton />
                    </SidePanelHeaderActions>
                </SidePanelHeaderMain>
            </SidePanelHeader>
            <SidePanelBody>
                <ListSkeleton className="p-4" />
            </SidePanelBody>
        </SidePanel>
    );
}
